module.exports = __webpack_public_path__ + "static/img/01zai.8267bfc4.gif";